import {
  associateTechTypes,
  postTechType,
  putTechDetails,
} from "../services/technologyDetails.service";
import { filterUnique } from "../utils/filter";
import { NotificationToaster } from "../utils/notificationToaster";

const addTechType = (data) => (dispatch, getState) => {
  const { technologies } = getState().wizard;
  return postTechType(data)
    .then((technologyResponse) => {
      const filteredTechnologies = filterUnique(
        technologies,
        technologyResponse,
        "technologyTypeID",
      );
      dispatch({ type: "UPDATE_TECH", payload: filteredTechnologies });
      return Promise.resolve(technologyResponse);
    })
    .catch((err) => {
      dispatch({ type: "UPDATE_TECH_ERROR", payload: err.message });
      NotificationToaster({ message: "Something went wrong", type: "error" });
    });
};

const associateTechTypesAction = () => (dispatch, getState) => {
  const { technologies, assignedClient } = getState().wizard;
  const technologyTypeIds =
    technologies.length > 0
      ? technologies.map((item) => item.technologyTypeID)
      : [];
  const payload = {
    carePlanId: assignedClient?.carePlanId ?? assignedClient?.carePlanID,
    technologyTypeIds,
  };
  return associateTechTypes(payload)
    .then((response) => {
      dispatch({ type: "TECH_ASSOCIATION_SUCCESS" });
      return Promise.resolve(response);
    })
    .catch((err) => {
      dispatch({ type: "TECH_ASSOCIATION_ERROR", payload: err.message });
      NotificationToaster({ message: "Something went wrong", type: "error" });
    });
};

const updateTechDetails = (clientId, data) => (dispatch, getState) => {
  const { techDetails } = getState().wizard;

  data.technologyDetails = !!data.technologyDetails
    ? data.technologyDetails.trim()
    : "";
  const payload = {
    userID: clientId,
    ...data,
  };

  if (techDetails?.technologyDetails !== payload?.technologyDetails) {
    return putTechDetails(payload)
      .then((response) => {
        dispatch({ type: "UPDATE_TECH_DETAILS", payload: data });
        return Promise.resolve(response);
      })
      .catch((err) => {
        dispatch({ type: "UPDATE_TECH_DETAILS_ERROR", payload: err.message });
        NotificationToaster({ message: "Something went wrong", type: "error" });
      });
  } else {
    return Promise.resolve();
  }
};

export { addTechType, associateTechTypesAction, updateTechDetails };
